import React from 'react'
import PropTypes from 'prop-types'
import EducationProfileEvent from './EducationProfileEvent'
import CreateEducationProfileEvent from './CreateEducationProfileEvent'
import EducationProfileMatch from './EducationProfileMatch'
import { parseISO, addDays } from 'date-fns'

CreateEducationProfileTimedEvent.propTypes = {
  eventType: PropTypes.string.isRequired,
  previousEventType: PropTypes.string.isRequired,
  timeInDays: PropTypes.number.isRequired
}

export default function CreateEducationProfileTimedEvent({
  eventType,
  previousEventType,
  timeInDays
}) {
  return (
    <EducationProfileMatch withoutEvents={[eventType]}>
      <EducationProfileEvent eventType={previousEventType}>
        {previousEvent => (
          <CreateEducationProfileEvent
            eventType={eventType}
            eventAt={newEventDate(previousEvent, timeInDays).toJSON()}
            triggerOnMount={timeReached(previousEvent, timeInDays)}
          />
        )}
      </EducationProfileEvent>
    </EducationProfileMatch>
  )
}

function timeReached(previousEvent, timeInDays) {
  return newEventDate(previousEvent, timeInDays) <= new Date()
}

function newEventDate(previousEvent, timeInDays) {
  return addDays(parseISO(previousEvent.eventAt), timeInDays)
}
